module.exports = __webpack_public_path__ + "img/a013_2.728694f7.jpg";